import { createAsyncThunk } from '@reduxjs/toolkit';
import { TDispatch, EBuyPackageStatus, TAppState } from '../../types';
import { IThunkContext } from '../../types/thunk';
import { notEnoughMoneyThunk } from '../notEnoughMoney';
import { packageContext } from '../../contexts/package/packageContext';
import { setBuyPackageModalError, setBuyPackageModalLoading, setBuyPackageModalStatus } from '../../slices';
import { paymentSuccess } from '../../services/event/paymentSuccess';
import { selectPackageInternalType } from '../../selectors/buyPackageModal';

const createBuyPackageAsyncThunk = createAsyncThunk.withTypes<{
  state: TAppState;
  dispatch: TDispatch;
  extra: IThunkContext;
}>();

export const buyPackageThunk = createBuyPackageAsyncThunk('BUY_PACKAGE', async (_, thunkApi) => {
  const {
    getState,
    dispatch,
    extra: { httpApi },
  } = thunkApi;

  try {
    const state = getState();

    const internalType = selectPackageInternalType(state);

    dispatch(setBuyPackageModalLoading(true));

    const response = await packageContext.buy(state, { httpApi });

    dispatch(setBuyPackageModalLoading(false));

    if (response.isSuccess) {
      switch (response.code) {
        case EBuyPackageStatus.Ok:
        case EBuyPackageStatus.OkWithDeposit:
          dispatch(setBuyPackageModalStatus(response.code));
          paymentSuccess(internalType);

          break;

        case EBuyPackageStatus.NotEnoughMoney:
          dispatch(notEnoughMoneyThunk());

          break;

        default:
          dispatch(setBuyPackageModalStatus(response.code));

          break;
      }
    } else {
      dispatch(setBuyPackageModalError(response.message));
    }
  } catch {
    dispatch(setBuyPackageModalError('Что-то пошло не так'));
  }
});
